<template>
  <div class="content">
    <h1 class="content__title">Kimia Shokrollahzade</h1>
    <div class="content__container">
      <h4 class="content__subtitle content__eduction">MSc Electronics Engineering</h4>
      <h4 class="content__subtitle content__work">&#60; Front End Engineer /&#62;</h4>
      <h5 class="content__description">If you are not making your own dream, you must be making others.</h5>
    <Social />
    </div>
  </div>
</template>

<script>
import Social from './Social'

export default {
  name: 'Head',
  components: {
    Social,
  }
}
</script>

<style lang="sass" scoped>
@import "@/styles/_variables.sass"

.content
  &__title
    color: $primary
    font-family: $font-secondary
    letter-spacing: 2px

  &__container
    max-width: 240px
    margin: 0 auto
    text-align: justify
    text-align-last: justify
    -webkit-text-align-last: justify
  &__description
    margin: 30px 0
    line-height: 1.2
    letter-spacing: 1.5px
    font-size: 11px
  &__subtitle
    text-align: center
    line-height: 1.5
  &__work
    letter-spacing: 1px
    font-size: 17px
    color: #fff
  &__eduction
    letter-spacing: 1px
    font-size: 14px
  &__skills
  &__skill
    font-size: 12px
    padding: 0 1px
    &:not(&:last-child):after 
      content: ','
      display: inline-block
</style>
